import { getApiErrorMessage } from "@api/apiError";

export interface BulkRequestGroupsOutcome<TGroup, TResult> {
    results: TResult[];
    failedMessages: string[];
    thrownGroups: TGroup[];
}

export async function runBulkRequestGroups<
    TGroup,
    TResult extends { failed: Array<{ message: string }> },
>(options: {
    groups: TGroup[];
    run: (group: TGroup) => Promise<TResult>;
    countRows: (group: TGroup) => number;
    fallbackMessage: string;
}): Promise<BulkRequestGroupsOutcome<TGroup, TResult>> {
    const outcome: BulkRequestGroupsOutcome<TGroup, TResult> = {
        results: [],
        failedMessages: [],
        thrownGroups: [],
    };
    for (const group of options.groups) {
        try {
            const result = await options.run(group);
            outcome.results.push(result);
            outcome.failedMessages.push(
                ...result.failed.map((row) => row.message),
            );
        } catch (mutationError) {
            const message = getApiErrorMessage(
                mutationError,
                options.fallbackMessage,
            );
            outcome.thrownGroups.push(group);
            outcome.failedMessages.push(
                ...Array.from(
                    { length: options.countRows(group) },
                    () => message,
                ),
            );
        }
    }
    return outcome;
}
